import { Route, Routes, useLocation } from "react-router-dom";
import "./App.scss";
import Frontpage from "./pages/Frontpage";
import VendorTypes from "./pages/VendorTypes";
import { useEffect } from "react";
import { supabase } from "./supabase";
import { useAppDispatch, useAppSelector } from "./hooks";
import { setIsAdmin, setVendors, setVendorTypes } from "./features/appSlice";
import Toast from "./components/notification/Toast";
import { removeToast } from "./features/notification/notificationSlice";
import Login from "./pages/Login";
import { getAllVendors, getAllVendorTypes } from "./api";
import VendorEditPage from "./pages/EditVendor";
import Vision from "./pages/Vision";
import About from "./pages/About";
import Footer from "./components/Footer";
import Vendors from "./pages/Vendors";
import ForVendors from "./pages/ForVendors";
import Admin from "./pages/AdminTable";
import ComingSoon from "./pages/ComingSoon";
import Dashboard from "./pages/Dashboard";

function App() {
  const dispatch = useAppDispatch();
  const toast = useAppSelector((state) => state.notification?.toast);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    getAllVendors().then((data) => {
      dispatch(setVendors(data));
    });

    getAllVendorTypes().then((data) => {
      dispatch(setVendorTypes(data.sort((a, b) => a.order - b.order)));
    });
  }, []);

  useEffect(() => {
    const { data: subscription } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (event === "SIGNED_OUT") {
          dispatch(setIsAdmin(false));
        }
        if (event === "SIGNED_IN" && !isAdmin) {
          dispatch(setIsAdmin(true));
        }
      }
    );

    return () => {
      subscription?.subscription.unsubscribe();
    };
  }, [dispatch, isAdmin]);

  return (
    <div className="App">
      {toast && <Toast toast={toast} onClose={() => dispatch(removeToast())} />}

      <Routes>
        <Route path="/" element={<>
          <Frontpage />
          <VendorTypes />
          <Vision />
          <ForVendors />
          <Footer />
        </>} />
        <Route path="/about" element={<About />} />
        <Route path="/vendors/:id" element={<Vendors />} />
        <Route path="/edit/:id" element={<VendorEditPage />} />
        <Route path="/admin" element={isAdmin ? <Admin /> : <Login />} />
        <Route path="/admin/dashboard" element={isAdmin ? <Dashboard /> : <Login />} />
        <Route path="*" element={<h2>404 - Siden blev ikke fundet</h2>} />
      </Routes>
    </div>
  );
}

export default App;